import React, { Component, useEffect, useState } from "react";
import { withRouter } from "react-router-dom";
import { Table, Input, Button, DatePicker } from "antd";
import { reactLocalStorage } from "reactjs-localstorage";
import { httpUrl, httpGet, httpDownload } from "../../api/httpClient";
import locale from "antd/es/date-picker/locale/ko_KR";
import excelPng from "../../img/excel.png";
import { utils, writeFile } from "xlsx";
import moment from "moment";
import SelectBox from "../../components/common/SelectBox";
import CoinSelectBox from "../../components/common/CoinSelectBox";
import { mergeLogCode } from "../../lib/util/codeUtil";
import {
  comma,
  formatDate,
  amountFormat,
  coinMultiFormat,
  coinDivideFormat
} from "../../lib/util/numberUtil";

const Search = Input.Search;
const RangePicker = DatePicker.RangePicker;

const MergeLogList = () => {

    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 10,
        total: 0,
    });
    const [type, setType] = useState(0);
    const [logList, setLogList] = useState([]);
    const [logType, setLogType] = useState("ALL");
    const [coinType, setCoinType] = useState(401);
    const [searchText, setSearchText] = useState("");
    const [isLoaded, setIsLoaded] = useState(false);
    const [date, setDate] = useState({
        start: moment().format("YYYY-MM-DD"),
        end: moment().format("YYYY-MM-DD")
      });
      const coinList = reactLocalStorage.getObject("coinList");

useEffect(() => {
    getLogList();
},[date.end, pagination.current, pagination.pageSize, searchText, date.start]);


  const getLogList = async () => {
    const pageSize = pagination.pageSize;
    const pageNum = pagination.current;
    const endDate = moment(date.end).add(1, 'd').format("YYYY-MM-DD");
 
    const res = await httpGet(httpUrl.getMergeLogList, [10, pageNum, logType, coinType, searchText, date.start, endDate], {})
    if (!res) {
        console.log(`getListAsync failed. result: ${res.result}`);
        return;
    }
    setLogList(res.data.mergeLogList);
    setPagination({
        ...pagination,
       current: res.data.currentPage,
        total: res.data.totalCount
    })
    setIsLoaded(false);
};

const handleTableChange = (page) => {
    if (page.current !== pagination.current) {
        setPagination({
            ...pagination,
            current: page.current
        });
    } else if (page.pageSize !== pagination.pageSize) {
        setPagination({
            ...pagination,
            current: 1,
            pageSize: page.pageSize
        });
    }
    getLogList();
};

//   const componentDidUpdate=(prevProps)=> {
//     const { match } = props;

//     if (match.params.logname !== prevProps.match.params.logname) {
//       this.setState({
//         logList: [],
//         pagination: {
//           total: 0,
//           current: 1,
//         },
//         logType: "ALL",
//         coinType: undefined,
//         startDate: "",
//         endDate: "",
//       });
//     }
//   }

    const logListColumn = [
      {
        title: "번호",
        dataIndex: "idx",
        key: "idx",
        className: "column-center",
        render: (data) => <div>{comma(data)}</div>,
      },
      {
        title: "주소",
        dataIndex: "address",
        key: "address",
        className: "column-center",
      },
      {
        title: "코인종류",
        dataIndex: "coinType",
        key: "coinType",
        className: "column-center",
        render: (data) => (
          <div>
            {coinList.find((list) => list.coinType === data).name}
          </div>
        ),
      },
      {
        title: "수수료",
        dataIndex: "fee",
        key: "fee",
        className: "column-center",
        render: (data, row, index) => (
          <span>{amountFormat(data, row.coinType)}</span>
        ),
      },
      {
        title: "상태",
        dataIndex: "status",
        key: "status",
        className: "column-center",
        render: (data) => <span>{mergeLogCode[data]}</span>,
      },
      {
        title: "일자",
        dataIndex: "createDate",
        key: "createDate",
        className: "column-center",
        render: (data) => <span>{formatDate(data)}</span>,
      },
      {
        title: "넌스",
        key: "nonce",
        dataIndex: "nonce",
        className: "column-center",
      },
      {
        title: "재전송",
        dataIndex: "nonce",
        className: "column-center",
        render: (data, row) => 
          <div>
            {row.status == 'PENDING' && row.trxId != 'Max rate limit reached' && (
              <a href={row.requestUrl} target='_blank' style={{marginRight: 20}}>재전송</a>
            )}
            <a href={"https://etherscan.io/tx/" + row.trxId} target='_blank'>이더스캔</a>
          </div>
      },
    ];

   const reset =() =>{
        setType(0)
        setDate({
            start: moment().format('YYYY-MM-DD'),
            end: moment().format('YYYY-MM-DD')
        })
        setSearchText("");
        setCoinType("");
        setLogType("ALL");
    };

    const onSearch = (value) => {
      if (!coinType) {
        alert("코인 종류를 선택해주세요.");
      } else {
          setSearchText(value);
          getLogList();
      }
    };

    const onSelectCoinType = (value) => {
        setCoinType(value);
        setIsLoaded(true);
    };
    
    const onSelectLogType = (value) => {
        setLogType(value);
        setIsLoaded(true);
    };
    
    const changeDate =(type) =>{
        if (type ==='today'){
            setType(0)
            setDate({
                start: moment().format('YYYY-MM-DD'),
                end: moment().format('YYYY-MM-DD')
            })
        } else if (type === 'week'){
            setType(1)
            setDate({
                start: moment().add(-7, 'd').format('YYYY-MM-DD'),
                end: moment().format('YYYY-MM-DD')
            })
        }else if (type === 'threeMonth'){
            setType(2)
            setDate({
                start:  moment().add(-3, 'M').format('YYYY-MM-DD'),
                end: moment().format('YYYY-MM-DD')
            })
        }else{
            setType(3)
            setDate({
                start: moment('2023-01-01').format('YYYY-MM-DD'),
                end: moment().format('YYYY-MM-DD')
            })
            }
    
    };
    
    const onChangeRangePicker = async (e, selectDate, value) => {
        setType(4)
        setDate({
            start: moment(selectDate[0]).format('YYYY-MM-DD'),
            end: moment(selectDate[1]).format('YYYY-MM-DD')
        })
    };

    const disabledDate = (current) => {
    return current && current > moment().endOf('day');
    };
      
    return (
        <div id= "MergeLogList"  className="main">
                <div className="main-title">
                모으기 내역
                </div>
                <div className="bank-bar">
                    <span>이더스캔에서 트랜잭션이 보이지 않고 전송이 지연되는 경우 "재전송"을 클릭하여 트랜잭션을 다시 보내주세요.<br/>
          재전송은 계속 클릭하셔도 무방합니다. (이중지불 되지 않습니다.)</span>
                </div>
                    <div className="top-bar">
                       <div id="selectBox">
                            <Button className={type === 0 && "active"} onClick={()=>changeDate('today')}>
                                금일
                            </Button>
                            <Button  className={type === 1 && "active"} onClick={()=>changeDate('week')}>
                                1주일
                            </Button>
                            <Button className={type === 2 && "active"} onClick={()=>changeDate('threeMonth')}>
                                3개월
                            </Button>
                            <Button className={type === 3 && "active"} onClick={()=>changeDate('all')}>
                                전체
                            </Button>
                            <p>
                            <RangePicker
                                style={{padding:5, borderRadius:5, marginRight:10,  border:'1px solid #888',height:32}}
                                locale={locale}
                                format={"YYYY-MM-DD"}
                                allowClear={false}
                                picker="date"
                                value={[
                                moment(date.start, "YYYY-MM-DD"),
                                moment(date.end, "YYYY-MM-DD"),
                                ]}
                                onChange={onChangeRangePicker}
                                disabledDate={disabledDate}
                            />
                            </p>
                            <CoinSelectBox
                                    name="searchType"
                                    className="memo-select2" 
                                    style={{width:150, marginRight:10,}}
                                    placeholder="코인 종류를 선택해주세요."
                                    onChange={(value) => {onSelectCoinType(value)}}
                                    value={coinType}
                                    exceptERC={false}
                                    exceptCoinType={[1, 3]}
                                />
                             <SelectBox
                                name="searchType"
                                className="memo-select" 
                                style={{width:100}}
                                placeholder={mergeLogCode['ALL']}
                                code={Object.keys(mergeLogCode)}
                                codeString={mergeLogCode}
                                onChange={(value) => {onSelectLogType(value)}}
                                value={logType}
                            />
                            <Input.Search
                                placeholder="주소를 입력해주세요"
                                className="search-input"
                                enterButton
                                allowClear
                                onSearch={onSearch}
                                value={searchText}
                                onChange={(e)=>{
                                    setSearchText(e.target.value.trim());
                                }}
                            />
                        </div>
                        <Button onClick={()=>reset()}>
                                초기화
                        </Button>
                    </div>
                   <div className="top-table">
                        <div className="top-table-container">
                                <div>
                                총 <span> {comma(pagination.total)}</span>건이 검색되었습니다.
                                </div>
                         </div>

                        <Table
                           rowKey={(record) => record.idx}
                           dataSource={logList}
                           columns={logListColumn}
                           pagination={pagination}
                           onChange={handleTableChange}
                        />
                     </div>
        </div>
    );
  
}

export default MergeLogList;
